import { SUCCESS_CODE } from '@/constants'
import Mock from 'mockjs'

export default [
  //  资产中心-厂商库-获取数据列表
  {
    url: '/mock/manufacturerLibrary/list',
    method: 'get',
    response: () => {
      const tableColumns: any[] = Array.from({ length: 10 }).map((_) => ({
        id: Mock.mock('@id'),
        companyId: Mock.mock('@id'), // 企业id
        companyName: Mock.mock('@csentence(5)'), // 企业名称
        companyAbbreviation: Mock.mock('@csentence(5)'), // 企业简称
        unifiedSocialCreditCode: Mock.mock('@csentence(5)'), // 统一社会信用代码（国外公司除外）
        eitiaLevelOne: Mock.mock('@csentence(5)'), // EITIA一级目录
        eitiaLevelTwo: Mock.mock('@csentence(5)'), // EITIA二级目录
        companyLogo: Mock.mock('@csentence(5)'), // 企业logo图片链接
        natureOfTheEnterprise: Mock.mock('@csentence(5)'), // 企业性质
        listing: Mock.mock('@csentence(5)'), // 企业是否上市（是/否）
        yearOfEstablishment: Mock.mock('@csentence(5)'), // 企业成立时间
        registeredCapital: Mock.mock('@csentence(5)'), // 企业注册资金
        annualRevenueRange: Mock.mock('@csentence(5)'), // 企业年度营收区间
        headquarters: Mock.mock('@csentence(5)'), // 企业总部所在地
        branchInformation: Mock.mock('@csentence(5)'), // 分支机构及办公地址
        officialWebsite: Mock.mock('@csentence(5)'), // 企业官网url
        companyProfile: Mock.mock('@csentence(5)'), // 企业简介
        corporateVideo: Mock.mock('@csentence(5)'), // 企业宣传片视频url
        corporateVisionMission: Mock.mock('@csentence(5)'), // 企业愿景及使命
        numberOfEmployees: Mock.mock('@csentence(5)') // 员工人数区间
      }))
      return {
        code: SUCCESS_CODE,
        data: {
          total: 10,
          list: tableColumns
        }
      }
    }
  }
]
